import { store } from '../store';
import { logout } from '../store/userSlice';

/**
 * Middleware simple qui détecte les erreurs 401 et déconnecte l'utilisateur
 * À utiliser avec les fonctions fetch pour gérer les tokens expirés
 */

/**
 * Redirige l'utilisateur vers la page de login
 */
export const redirectToLogin = (): void => {
  // Utiliser window.location pour une redirection complète (rafraîchit la page)
  window.location.href = '/login';
};

/**
 * Vérifie si la réponse est une erreur 401 (Unauthorized)
 * Si oui, déconnecte l'utilisateur et redirige vers la page login
 */
export const handleUnauthorizedError = (response: Response): boolean => {
  if (response.status === 401) {
    console.warn('Session expirée ou token invalide. Déconnexion en cours...');
    
    // Dispatch l'action logout pour vider le store
    store.dispatch(logout());
    
    // Supprimer toutes les données d'authentification du localStorage
    localStorage.removeItem('user');
    
    // Rediriger vers la page de login
    redirectToLogin();
    
    return true;
  }
  
  return false;
};
